<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.START"
    :handler="
      (data) => {
        if (data?.option) {
          operation = data.option;
          $refs.bookmakerModal.show();
        } else $refs.operationModal.show();
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="
      () => {
        $refs.operationModal.hide();
        $refs.bookmakerModal.hide();
      }
    "
  />

  <!-- First Dialog: Operation Selection -->
  <DialogComponent
    ref="operationModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
    :mainClass="
      ({ isLastDialog }) =>
        isLastDialog
          ? '[&_.formContainer]:duration-300'
          : '[&_.formContainer]:opacity-0 [&.formContainer]:duration-300'
    "
  >
    <!-- Header -->
    <div class="absolute flex w-full">
      <ColorImg
        src="/images/leaderboard/cardHeadForm.svg"
        class="bg-indigo-500 w-full absolute -bottom-5"
        alt=""
      />
    </div>
    <div class="bg-indigo-500 relative">
      <div class="relative px-6 pt-0 pb-8">
        <p class="text-white/70 text-sm font-medium uppercase tracking-wide">
          Que voulez-vous faire ?
        </p>
        <h2 class="text-white font-bold text-2xl mt-1">
          Choisissez une opération
        </h2>
      </div>

      <div class="scale-x-[-1]">
        <svg
          class="absolute bottom-0 left-0 right-0"
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          style="height: 28px"
        >
          <path
            d="M0 60V0C240 35 480 55 720 55S1200 35 1440 0V60H0Z"
            fill="white"
          />
        </svg>
      </div>
    </div>

    <!-- Services List -->
    <div class="px-5 pb-6 bg-white mt-4">
      <div class="flex flex-col gap-3">
        <!-- Recharge -->
        <div
          class="group flex items-center gap-4 p-4 rounded-2xl border-2 border-transparent bg-gray-50 hover:bg-gray-100 cursor-pointer transition-all duration-200"
          @click="
            operation = 'fund';
            $refs.bookmakerModal.show();
          "
        >
          <div
            class="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center flex-shrink-0"
          >
            <ColorImg
              src="/images/servicesOptions/fund.svg"
              class="w-6 h-6 bg-white"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-lg text-gray-900">Recharge</div>
            <div class="text-gray-500 text-sm">Déposer sur un compte</div>
          </div>
          <div
            class="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>

        <!-- Retrait -->
        <div
          class="group flex items-center gap-4 p-4 rounded-2xl border-2 border-transparent bg-gray-50 hover:bg-gray-100 cursor-pointer transition-all duration-200"
          @click="
            operation = 'withdraw';
            $refs.bookmakerModal.show();
          "
        >
          <div
            class="w-12 h-12 rounded-xl bg-gradient-to-br from-rose-400 to-rose-600 flex items-center justify-center flex-shrink-0"
          >
            <ColorImg
              src="/images/servicesOptions/withdraw.svg"
              class="w-6 h-6 bg-white"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-lg text-gray-900">Retrait</div>
            <div class="text-gray-500 text-sm">Retirer depuis un compte</div>
          </div>
          <div
            class="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>

        <!-- Acheter -->
        <div
          class="group flex items-center gap-4 p-4 rounded-2xl border-2 border-transparent bg-gray-50 hover:bg-gray-100 cursor-pointer transition-all duration-200"
          :class="{
            'grayscale opacity-50 pointer-events-none': !isOptionAvailable(
              'usdt',
              'buy'
            )
          }"
          @click="
            $bus.emit(
              $constants.EVENTS.SERVICES.OPTIONS.SELECTED,
              $constants.SERVICES.SERVICES_OPTIONS['usdt']?.[0]
            )
          "
        >
          <div
            class="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center flex-shrink-0"
          >
            <ColorImg
              src="/images/servicesOptions/buy.svg"
              class="w-6 h-6 bg-white"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-lg text-gray-900">Acheter</div>
            <div class="text-gray-500 text-sm">Acheter de la crypto</div>
          </div>
          <div
            class="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>

        <!-- Vendre -->
        <div
          class="group flex items-center gap-4 p-4 rounded-2xl border-2 border-transparent bg-gray-50 hover:bg-gray-100 cursor-pointer transition-all duration-200"
          :class="{
            'grayscale opacity-50 pointer-events-none': !isOptionAvailable(
              'usdt',
              'sell'
            )
          }"
          @click="
            $bus.emit(
              $constants.EVENTS.SERVICES.OPTIONS.SELECTED,
              $constants.SERVICES.SERVICES_OPTIONS['usdt']?.[1]
            )
          "
        >
          <div
            class="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center flex-shrink-0"
          >
            <ColorImg
              src="/images/servicesOptions/sell.svg"
              class="w-6 h-6 bg-white"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-lg text-gray-900">Vendre</div>
            <div class="text-gray-500 text-sm">Vendre de la crypto</div>
          </div>
          <div
            class="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>

  <!-- Second Dialog: Service Selection -->
  <DialogComponent
    ref="bookmakerModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
    :mainClass="
      ({ isLastDialog }) =>
        isLastDialog
          ? '[&_.formContainer]:duration-300'
          : '[&_.formContainer]:opacity-0 [&.formContainer]:duration-300'
    "
  >
    <!-- Header -->
    <div class="absolute flex w-full">
      <ColorImg
        src="/images/leaderboard/cardHeadForm.svg"
        class="bg-indigo-500 w-full absolute -bottom-5"
        alt=""
      />
    </div>
    <div class="bg-indigo-500 relative">
      <div class="relative px-6 pt-0 pb-8">
        <div class="flex items-center gap-3">
          <button
            @click="$refs.bookmakerModal.hide()"
            class="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div>
            <p
              class="text-white/70 text-sm font-medium uppercase tracking-wide"
            >
              Service
            </p>
            <h2 class="text-white font-bold text-xl">{{ operationTitle }}</h2>
          </div>
        </div>
      </div>

      <div class="scale-x-[-1]">
        <svg
          class="absolute bottom-0 left-0 right-0"
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          style="height: 28px"
        >
          <path
            d="M0 60V0C240 35 480 55 720 55S1200 35 1440 0V60H0Z"
            fill="white"
          />
        </svg>
      </div>
    </div>

    <!-- Services List -->
    <div class="px-5 pb-6 bg-white mt-4">
      <div class="flex flex-col gap-3">
        <div
          v-for="service in rechargeServices"
          :key="service.id"
          class="group flex items-center gap-4 p-4 rounded-2xl border-2 border-gray-100 hover:border-indigo-200 cursor-pointer transition-all duration-200 hover:shadow-md"
          :class="{
            'grayscale opacity-50 pointer-events-none': !isOptionAvailable(
              service.id,
              operation
            )
          }"
          @click="selectService(service)"
        >
          <div
            class="w-14 h-14 rounded-xl bg-gray-100 flex items-center justify-center flex-shrink-0 overflow-hidden"
          >
            <ImgComponent
              :src="service.logo"
              class="w-full h-full object-contain p-2"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-lg text-gray-900 truncate">
              {{ getServiceOption(service)?.title }}
            </div>
            <div class="text-gray-500 text-sm truncate">
              {{ getServiceOption(service)?.description }}
            </div>
          </div>
          <div
            class="w-8 h-8 rounded-full bg-gray-100 group-hover:bg-indigo-100 flex items-center justify-center transition-colors"
          >
            <svg
              class="w-4 h-4 text-gray-400 group-hover:text-indigo-500 transition-colors"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const { $stores, $bus, $constants } = proxy;

const operation = ref(null);

const operationTitle = computed(() => {
  return operation.value === 'fund' ? 'Recharge' : 'Retrait';
});

const rechargeServices = computed(() => {
  return $constants.SERVICES.SERVICES_LIST.filter(
    (s) => s.group === 'recharges'
  );
});

const getServiceOption = (service) => {
  const index = operation.value === 'fund' ? 0 : 1;
  return $constants.SERVICES.SERVICES_OPTIONS[service.id]?.[index];
};

const selectService = (service) => {
  const index = operation.value === 'fund' ? 0 : 1;
  const option = $constants.SERVICES.SERVICES_OPTIONS[service.id]?.[index];
  if (option) {
    $bus.emit($constants.EVENTS.SERVICES.OPTIONS.SELECTED, option);
  }
};

const isOptionAvailable = (serviceId, operationId) => {
  const countryCode = $stores.user.state.current?.countryCode;
  const appData = $stores.appData.state.data;

  const operationKeys = {
    'fund:1xbet': 'fund1xBet',
    'withdraw:1xbet': 'withdrawal1xBet',
    'fund:betwinner': 'fundBetWinner',
    'withdraw:betwinner': 'withdrawalBetWinner',
    'fund:1win': 'fund1Win',
    'withdraw:1win': 'withdrawal1Win',
    'fund:melbet': 'fundMelbet',
    'withdraw:melbet': 'withdrawalMelbet',
    'fund:eightStarz': 'fundEightStarz',
    'withdraw:eightStarz': 'withdrawalEightStarz',
    'buy:usdt': 'buyUsdt',
    'sell:usdt': 'sellUsdt'
  };

  const key = `${operationId}:${serviceId}`;
  const opKey = operationKeys[key];
  if (!opKey) return true;

  return appData?.serviceAvailability?.[countryCode]?.[opKey] ?? true;
};
</script>
